export default "__VITE_ASSET__Bsi15seF__"